export default "__VITE_ASSET__Biy6mW1u__"